import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeRedirectToken } from "../services/api";
import { useHotel } from "../contexts/HotelContext";

const LoginRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { refreshUser } = useHotel();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirectToken = params.get("rt");

    if (!redirectToken) {
      setError("Nie znaleziono tokenu przekierowania");
      setTimeout(() => navigate("/login"), 3000);
      return;
    }

    // Exchange redirect token for JWT
    exchangeRedirectToken(redirectToken)
      .then(async ({ access_token }) => {
        // Save JWT to localStorage
        localStorage.setItem("token", access_token);

        // Refresh user data from context
        await refreshUser();

        // Redirect to dashboard
        navigate("/");
      })
      .catch((err) => {
        console.error("Token exchange failed:", err);
        setError(
          "Uwierzytelnienie nie powiodło się. Spróbuj zalogować się ponownie."
        );
        setTimeout(() => navigate("/login"), 3000);
      });
  }, [location, navigate, refreshUser]);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
      <div className="text-center max-w-md">
        {error ? (
          <>
            <div className="text-red-600 text-xl font-semibold mb-4">
              {error}
            </div>
            <p className="text-neutral-600">
              Przekierowanie do strony logowania...
            </p>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-semibold text-neutral-900">
              Uwierzytelnianie...
            </h2>
            <p className="text-neutral-600 mt-2">
              Konfigurowanie sesji. Proszę czekać.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginRedirect;
